// Sexagesimal hours helpers. Internal storage remains float (decimal hours),
// display and input use H:MM format.

export function formatHM(hours) {
    if (hours == null || hours === "" || Number.isNaN(Number(hours))) return "";
    const totalMin = Math.round(Number(hours) * 60);
    const sign = totalMin < 0 ? "-" : "";
    const abs = Math.abs(totalMin);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    return `${sign}${h}:${String(m).padStart(2, "0")}`;
}

export function parseHM(str) {
    if (str == null) return null;
    const s = String(str).trim();
    if (!s) return null;
    // Plain integer or decimal → interpret as hours (kept for tolerance)
    if (/^-?\d+(?:[.,]\d+)?$/.test(s)) {
        return parseFloat(s.replace(",", "."));
    }
    const m = s.match(/^(-?)(\d+):(\d{1,2})$/);
    if (!m) return null;
    const sign = m[1] === "-" ? -1 : 1;
    const h = parseInt(m[2], 10);
    const min = parseInt(m[3], 10);
    if (min > 59) return null;
    return sign * (h + min / 60);
}
